import { VkOrdHistoryResponse } from '@synapex/shared2/gateway-rest-api'

export const HISTORY_ITEM_STATUS: Record<
    VkOrdHistoryResponse['lastUpdateStatus'],
    { text: string; style: React.CSSProperties }
> = {
    verified: { text: 'Успешно', style: { color: 'rgba(82, 208, 93, 1)' } },
    bad: { text: 'Ошибка', style: { color: 'rgba(255, 134, 118, 1)' } },
    processing: {
        text: 'В процессе',
        style: { color: 'rgba(246, 164, 11, 1)' },
    },
    waiting_upload: {
        text: 'Ожидание загрузки',
        style: { color: '#35B2FF' },
    },
}
